class BackoffTimer {
  constructor(callback, interval = 0.6) {
    this.callback = callback
    this.interval = interval
    this.originalInterval = interval
    this.stopped = false
  }

  start() {
    this.stopped = false
    this.call()
  }

  stop() {
    this.stopped = true
    this.interval = this.originalInterval
  }

  call() {
    setTimeout(() => {
      if (this.stopped) return

      this.callback()

      this.interval = this.nextInterval()
      this.call()
    }, this.interval * 1000)
  }

  nextInterval() {
    const jiggleFactor = 0.25 // randomly adjust up to +/- 25% of the multiplier to prevent clients from synchronizing
    const random = this.randomFloatBetween(1 - jiggleFactor, 1 + jiggleFactor)
    const jiggledMultiplier = this.backoffMultiplier() * random
    return this.interval * Math.max(jiggledMultiplier, 1.1) // ensure that the delay *always* increases: minimum 1.1
  }

  backoffMultiplier() {
    // after polling for 10 mins make the growth more exponential to not grind the backend if a user leaves a page open
    return this.interval < 600 ? 1.6 : 5
  }

  randomFloatBetween(min, max) {
    return Math.random() * (max - min) + min
  }
}

export default BackoffTimer
